export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.icon.accounting';
export const APP_STORE_URL = 'https://apps.apple.com/id/app/icon-accounting/id1553342761';
